
import {Login} from '@osjs/client';
import axios from 'axios';


export default class MyCustomLogin extends Login {
  async render() {
    // Set a custom class name
    this.$container.className = 'custom-osjs-login';
    console.log(this.core.user)
     // Bind the events
    this.on('login:start', () => console.log('Currently trying to log in...'));
    this.on('login:stop', () => console.log('Login was aborted or stopped'));
    this.on('login:error', err => console.error('An error occured while logging in', err));
    let user = {};
    let has_session = false;
    await axios.get('/oauth/success')
      .then(function (response) {
        // handle success
        if(response.data.user){
          user = response.data.user._json.user
          has_session = true;
        }
        

      })
      .catch(function (error) {
        console.log(error);
      })
      
    if(has_session){
      this.emit('login:post', {
        username: user.name
      });
    }else{
        window.location.href=process.env.APP_LOGIN
    }
    // Add your HTML content
    

    // To submit a login form (ex when you press a button):
  
    
  }
}